<template>
    <section id="sectionAboutUs" class="row mt-2 mt-lg-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">Về chúng tôi</h1>
                    </div>
                </div>
            </div>
            <div class="row mt-1 mt-lg-3">
                <div class="col-12">
                    <div class="row">
                        <div class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item" :class="{'active': itemIndex === 0}" v-for="(itemValue, itemIndex) in aboutUsSlider.itemsList" :key="'item' + itemIndex">
                                    <img :src="assetsBaseUrl + itemValue.filePath" class="d-block w-100">
                                </div>
                            </div>
                        </div>
                        <blockquote class="blockquote text-center">
                            <p>{{ aboutUsSlider.sliderDescription }}</p>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AboutUsComponent",
        data() {
            return {
                assetsBaseUrl: process.env.VUE_APP_API_DOMAIN + process.env.VUE_APP_ASSETS_PATH + '/',
                aboutUsSlider: this.$store.state.sliders.aboutUsSlider
            }
        }
    }
</script>

<style scoped>

</style>
